function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M55.504 57.668V26.813c0-3.035-2.469-5.504-5.504-5.504s-5.504 2.469-5.504 5.504v30.855a11.187 11.187 0 00-5.73 9.793c0 6.195 5.039 11.234 11.234 11.234s11.234-5.04 11.234-11.234c0-4.094-2.184-7.8-5.73-9.793zM50 77.133c-5.332 0-9.672-4.34-9.672-9.672a9.638 9.638 0 015.301-8.629l.426-.219V48.9h4.789v-1.563h-4.79V40.36h2.837v-1.563h-2.836v-2.93h2.836v-1.562h-2.836v-7.5a3.945 3.945 0 013.941-3.942 3.945 3.945 0 013.942 3.942v20.527h-1.454v1.562h1.454v9.715l.425.219a9.634 9.634 0 015.301 8.629c.008 5.336-4.332 9.676-9.664 9.676z"
});

function SvgIconTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default SvgIconTemperature;